import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Map, TileLayer, Marker } from "react-leaflet";
import { debounce, cloneDeep } from "lodash";
import {
  Avatar,
  Breadcrumb,
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  Modal,
  Row,
  Switch,
  Tabs,
  Table,
  Tooltip,
  Typography,
  Upload,
  message,
} from "antd";
import {
  DeleteOutlined,
  EditOutlined,
  EyeOutlined,
  InboxOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { SetRoute } from "../scripts/action";
import { Constants } from "../scripts/settings";
import API from "../scripts/api";
import Resources from "../scripts/resources";
import PaginationInfo from "../components/PaginationInfo";
import CountTypeForm from "../forms/CountType";
import ShelfForm from "../forms/Shelf";
import ProductRowForm from "../forms/ProductRow";
import PrintSizeForm from "../forms/PrintSize";
import ProductIdentifierForm from "../forms/ProductIdentifier";



class CountTypes extends Component {
  constructor() {
    super();

    this.state = {
      categories: [],
      data: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      tags: [],
    };

    this.formRef = React.createRef();
  }

  fetch = (params = {}) => {
    this.setState({ loading: true });

    API.countType
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.data.current_page,
                pageSize: result.data.per_page,
                total: result.data.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showForm = (slider = {}) => {
    this.setState({ visibleForm: true, selected: slider });

    setTimeout(() => {
      this.formRef.current.handleDidMount(slider);
    }, 0);
  };

  hideForm = () => {
    this.setState({ visibleForm: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };


  handleDelete = (id) => {
    Modal.confirm({
      title: Resources.confirmDelete,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.countType
          .delete(id)
          .then((result) => {
            message.success(result.message);
            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmit = (values) => {
    const action = this.state.selected.id ? API.countType.update : API.countType.add;

    this.setState({ submitting: true });

    action(values, this.state.selected.id)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideForm();
        this.fetch({ page: this.state.pagination.current });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleTable = (pagination) => {
    this.fetch({ page: pagination.current });
  };

  componentDidMount() {
    this.fetch({ page: 1 });
  }

  render() {
    const {
      data,
      loading,
      pagination,
      submitting,
      visibleForm,
    } = this.state;

    const columns = [

      {
        title: Resources.title,
        dataIndex: "title",
        className: "col-center",
      },

      {
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
            <Tooltip title={Resources.edit}>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => this.showForm(record)}
              />
            </Tooltip>
            <Tooltip title={Resources.delete}>
              <Button
                type="link"
                icon={<DeleteOutlined />}
                onClick={() => this.handleDelete(val)}
              />
            </Tooltip>
          </Fragment>
        ),
      },
    ];

    return (
      <Fragment>
        <Row gutter={24} style={{ marginBottom: 16 }}>
          <Col xs={24} md={4}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => this.showForm()}
              block
            >
              {Resources.add}
            </Button>
          </Col>
        </Row>
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          onChange={this.handleTable}
          pagination={pagination}
          size="small"
          rowKey="id"
          scroll={{ x: 600 }}
        />
        {!!pagination.total && (
          <PaginationInfo
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={pagination.total}
            style={{ bottom: 0, right: 0 }}
          />
        )}
        <CountTypeForm
          ref={this.formRef}
          onCancel={this.hideForm}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={visibleForm}
        />
      </Fragment>
    );
  }
}
class Shlfs extends Component {
  constructor() {
    super();

    this.state = {
      categories: [],
      data: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      tags: [],
    };

    this.formRef = React.createRef();
  }

  fetch = (params = {}) => {
    this.setState({ loading: true });

    API.shelf
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.data.current_page,
                pageSize: result.data.per_page,
                total: result.data.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showForm = (slider = {}) => {
    this.setState({ visibleForm: true, selected: slider });

    setTimeout(() => {
      this.formRef.current.handleDidMount(slider);
    }, 0);
  };

  hideForm = () => {
    this.setState({ visibleForm: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };


  handleDelete = (id) => {
    Modal.confirm({
      title: Resources.confirmDelete,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.shelf
          .delete(id)
          .then((result) => {
            message.success(result.message);
            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmit = (values) => {
    const action = this.state.selected.id ? API.shelf.update : API.shelf.add;

    this.setState({ submitting: true });

    action(values, this.state.selected.id)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideForm();
        this.fetch({ page: this.state.pagination.current });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleTable = (pagination) => {
    this.fetch({ page: pagination.current });
  };

  componentDidMount() {
    this.fetch({ page: 1 });
  }

  render() {
    const {
      data,
      loading,
      pagination,
      submitting,
      visibleForm,
    } = this.state;

    const columns = [

      {
        title: Resources.title,
        dataIndex: "title",
        className: "col-center",
      },

      {
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
            <Tooltip title={Resources.edit}>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => this.showForm(record)}
              />
            </Tooltip>
            <Tooltip title={Resources.delete}>
              <Button
                type="link"
                icon={<DeleteOutlined />}
                onClick={() => this.handleDelete(val)}
              />
            </Tooltip>
          </Fragment>
        ),
      },
    ];

    return (
      <Fragment>
        <Row gutter={24} style={{ marginBottom: 16 }}>
          <Col xs={24} md={4}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => this.showForm()}
              block
            >
              {Resources.add}
            </Button>
          </Col>
        </Row>
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          onChange={this.handleTable}
          pagination={pagination}
          size="small"
          rowKey="id"
          scroll={{ x: 600 }}
        />
        {!!pagination.total && (
          <PaginationInfo
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={pagination.total}
            style={{ bottom: 0, right: 0 }}
          />
        )}
        <ShelfForm
          ref={this.formRef}
          onCancel={this.hideForm}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={visibleForm}
        />
      </Fragment>
    );
  }
}
class Rows extends Component {
  constructor() {
    super();

    this.state = {
      categories: [],
      data: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      tags: [],
    };

    this.formRef = React.createRef();
  }

  fetch = (params = {}) => {
    this.setState({ loading: true });

    API.productRow
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.data.current_page,
                pageSize: result.data.per_page,
                total: result.data.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showForm = (slider = {}) => {
    this.setState({ visibleForm: true, selected: slider });

    setTimeout(() => {
      this.formRef.current.handleDidMount(slider);
    }, 0);
  };

  hideForm = () => {
    this.setState({ visibleForm: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };


  handleDelete = (id) => {
    Modal.confirm({
      title: Resources.confirmDelete,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.productRow
          .delete(id)
          .then((result) => {
            message.success(result.message);
            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmit = (values) => {
    const action = this.state.selected.id ? API.productRow.update : API.productRow.add;

    this.setState({ submitting: true });

    action(values, this.state.selected.id)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideForm();
        this.fetch({ page: this.state.pagination.current });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleTable = (pagination) => {
    this.fetch({ page: pagination.current });
  };

  componentDidMount() {
    this.fetch({ page: 1 });
  }

  render() {
    const {
      data,
      loading,
      pagination,
      submitting,
      visibleForm,
    } = this.state;

    const columns = [

      {
        title: Resources.title,
        dataIndex: "title",
        className: "col-center",
      },

      {
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
            <Tooltip title={Resources.edit}>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => this.showForm(record)}
              />
            </Tooltip>
            <Tooltip title={Resources.delete}>
              <Button
                type="link"
                icon={<DeleteOutlined />}
                onClick={() => this.handleDelete(val)}
              />
            </Tooltip>
          </Fragment>
        ),
      },
    ];

    return (
      <Fragment>
        <Row gutter={24} style={{ marginBottom: 16 }}>
          <Col xs={24} md={4}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => this.showForm()}
              block
            >
              {Resources.add}
            </Button>
          </Col>
        </Row>
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          onChange={this.handleTable}
          pagination={pagination}
          size="small"
          rowKey="id"
          scroll={{ x: 600 }}
        />
        {!!pagination.total && (
          <PaginationInfo
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={pagination.total}
            style={{ bottom: 0, right: 0 }}
          />
        )}
        <ProductRowForm
          ref={this.formRef}
          onCancel={this.hideForm}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={visibleForm}
        />
      </Fragment>
    );
  }
}
class PrintSizes extends Component {
  constructor() {
    super();

    this.state = {
      categories: [],
      data: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      tags: [],
    };

    this.formRef = React.createRef();
  }

  fetch = (params = {}) => {
    this.setState({ loading: true });

    API.printSize
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.data.current_page,
                pageSize: result.data.per_page,
                total: result.data.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showForm = (slider = {}) => {
    this.setState({ visibleForm: true, selected: slider });

    setTimeout(() => {
      this.formRef.current.handleDidMount(slider);
    }, 0);
  };

  hideForm = () => {
    this.setState({ visibleForm: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };


  handleDelete = (id) => {
    Modal.confirm({
      title: Resources.confirmDelete,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.printSize
          .delete(id)
          .then((result) => {
            message.success(result.message);
            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmit = (values) => {
    const action = this.state.selected.id ? API.printSize.update : API.printSize.add;

    this.setState({ submitting: true });

    action(values, this.state.selected.id)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideForm();
        this.fetch({ page: this.state.pagination.current });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleTable = (pagination) => {
    this.fetch({ page: pagination.current });
  };

  componentDidMount() {
    this.fetch({ page: 1 });
  }

  render() {
    const {
      data,
      loading,
      pagination,
      submitting,
      visibleForm,
    } = this.state;

    const columns = [

      {
        title: Resources.title,
        dataIndex: "title",
        className: "col-center",
      },
      {
        title: Resources.withCM,
        dataIndex: "width",
        className: "col-center",
      },
      {
        title: Resources.heightCM,
        dataIndex: "height",
        className: "col-center",
      },
      {
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
            <Tooltip title={Resources.edit}>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => this.showForm(record)}
              />
            </Tooltip>
            <Tooltip title={Resources.delete}>
              <Button
                type="link"
                icon={<DeleteOutlined />}
                onClick={() => this.handleDelete(val)}
              />
            </Tooltip>
          </Fragment>
        ),
      },
    ];

    return (
      <Fragment>
        <Row gutter={24} style={{ marginBottom: 16 }}>
          <Col xs={24} md={4}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => this.showForm()}
              block
            >
              {Resources.add}
            </Button>
          </Col>
        </Row>
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          onChange={this.handleTable}
          pagination={pagination}
          size="small"
          rowKey="id"
          scroll={{ x: 600 }}
        />
        {!!pagination.total && (
          <PaginationInfo
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={pagination.total}
            style={{ bottom: 0, right: 0 }}
          />
        )}
        <PrintSizeForm
          ref={this.formRef}
          onCancel={this.hideForm}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={visibleForm}
        />
      </Fragment>
    );
  }
}
class ProductIdentifiers extends Component {
  constructor() {
    super();

    this.state = {
      categories: [],
      data: [],
      pagination: {
        total: 0,
        current: 1,
        pageSize: Constants.pageSize,
        size: "small",
      },
      tags: [],
    };

    this.formRef = React.createRef();
  }

  fetch = (params = {}) => {
    this.setState({ loading: true });

    API.productIdentifier
      .list(params)
      .then((result) => {
        if (result.data) {
          this.setState({
            loading: false,
            data: result.data.data,
            pagination: {
              ...this.state.pagination,
              ...{
                current: result.data.current_page,
                pageSize: result.data.per_page,
                total: result.data.total,
              },
            },
          });
        } else {
          this.setState({ loading: false });
        }
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  showForm = (slider = {}) => {
    this.setState({ visibleForm: true, selected: slider });

    setTimeout(() => {
      this.formRef.current.handleDidMount(slider);
    }, 0);
  };

  hideForm = () => {
    this.setState({ visibleForm: false });

    setTimeout(() => {
      this.formRef.current.handleWillUnmount();
    }, 0);
  };


  handleDelete = (id) => {
    Modal.confirm({
      title: Resources.confirmDelete,
      okText: Resources.yes,
      okType: "danger",
      cancelText: Resources.no,
      onOk: () => {
        this.setState({ loading: true });

        API.productIdentifier
          .delete(id)
          .then((result) => {
            message.success(result.message);
            this.fetch({ page: this.state.pagination.current });
          })
          .catch(() => {
            this.setState({ loading: false });
          });
      },
    });
  };

  handleSubmit = (values) => {
    const action = this.state.selected.id ? API.productIdentifier.update : API.productIdentifier.add;

    this.setState({ submitting: true });

    action(values, this.state.selected.id)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.hideForm();
        this.fetch({ page: this.state.pagination.current });
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  handleTable = (pagination) => {
    this.fetch({ page: pagination.current });
  };

  componentDidMount() {
    this.fetch({ page: 1 });
  }

  render() {
    const {
      data,
      loading,
      pagination,
      submitting,
      visibleForm,
    } = this.state;

    const columns = [

      {
        title: Resources.title,
        dataIndex: "title",
        className: "col-center",
      },
      {
        title: Resources.description,
        dataIndex: "description",
        className: "col-center",
      },

      {
        title: Resources.action,
        dataIndex: "id",
        className: "col-center",
        width: "120px",
        render: (val, record) => (
          <Fragment>
            <Tooltip title={Resources.edit}>
              <Button
                type="link"
                icon={<EditOutlined />}
                onClick={() => this.showForm(record)}
              />
            </Tooltip>
            <Tooltip title={Resources.delete}>
              <Button
                type="link"
                icon={<DeleteOutlined />}
                onClick={() => this.handleDelete(val)}
              />
            </Tooltip>
          </Fragment>
        ),
      },
    ];

    return (
      <Fragment>
        <Row gutter={24} style={{ marginBottom: 16 }}>
          <Col xs={24} md={4}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() => this.showForm()}
              block
            >
              {Resources.add}
            </Button>
          </Col>
        </Row>
        <Table
          columns={columns}
          dataSource={data}
          loading={loading}
          onChange={this.handleTable}
          pagination={pagination}
          size="small"
          rowKey="id"
          scroll={{ x: 600 }}
        />
        {!!pagination.total && (
          <PaginationInfo
            current={pagination.current}
            pageSize={pagination.pageSize}
            total={pagination.total}
            style={{ bottom: 0, right: 0 }}
          />
        )}
        <ProductIdentifierForm
          ref={this.formRef}
          onCancel={this.hideForm}
          onSubmit={this.handleSubmit}
          submitting={submitting}
          visible={visibleForm}
        />
      </Fragment>
    );
  }
}


class SettingsPage extends Component {
  constructor() {
    super();

    this.state = {
      activeTab: "1",
      data: {},
    };

    this.formRankRef = React.createRef();
    this.formShareRef = React.createRef();
    this.formTermsRef = React.createRef();
    this.formContactRef = React.createRef();
    this.formTransportRef = React.createRef();
  }

  fetch = () => {
    this.setState({ loading: true });

    API.setting
      .list()
      .then((result) => {
        if (result.data.phones) {
          if (result.data.phones.length > 0)
            result.data.phoneOne = result.data.phones[0];

          if (result.data.phones.length > 1)
            result.data.phoneTwo = result.data.phones[1];

          if (result.data.phones.length > 2)
            result.data.phoneThree = result.data.phones[2];

          if (result.data.phones.length > 3)
            result.data.phoneFour = result.data.phones[3];
        }

        this.setState({ loading: false, data: result.data });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleMap = (e = {}) => {
    this.formContactRef.current.setFieldsValue({
      lat: e.latlng.lat,
      lng: e.latlng.lng,
    });
  };

  handleTabChange = (tab) => {
    this.setState({ activeTab: tab });

    setTimeout(() => {
      const data = cloneDeep(this.state.data);
      switch (tab) {

        case "6":
          this.formShareRef.current.setFieldsValue(data);
          break;
        case "7":
          this.formTermsRef.current.setFieldsValue(data);
          break;
        case "8":
          this.formContactRef.current.setFieldsValue(data);
          break;
        case "9":
          this.formTransportRef.current.setFieldsValue(data);
          break;
        default:
          break;
      }
    }, 0);
  };

  handleSubmit = (values) => {
    this.setState({ submitting: true });

    const formData = new FormData();

    switch (this.state.activeTab) {
      case "4":
        formData.append("goldenRank", values.goldenRank);
        formData.append("silverRank", values.silverRank);
        formData.append("bronzeRank", values.bronzeRank);
        formData.append("scoreText", values.scoreText);
        break;
      case "6":
        formData.append("inviteText", values.inviteText);
        if (
          values.inviteImage &&
          values.inviteImage.fileList &&
          values.inviteImage.fileList.length
        )
          formData.append(
            "inviteImage",
            values.image.file,
            values.image.file.name
          );
        break;
      case "7":
        formData.append("rules", values.rules);
        break;
      case "8":
        if (values.phoneOne) formData.append("phones[]", values.phoneOne);
        if (values.phoneTwo) formData.append("phones[]", values.phoneTwo);
        if (values.phoneThree) formData.append("phones[]", values.phoneThree);
        if (values.phoneFour) formData.append("phones[]", values.phoneFour);

        formData.append("supportPhone", values.supportPhone);
        formData.append("supportPhone", values.supportPhone);
        formData.append("websiteLink", values.websiteLink);
        formData.append("mailAddress", values.mailAddress);
        formData.append("telegramId", values.telegramId);
        formData.append("instagramId", values.instagramId);
        formData.append("address", values.address);
        formData.append("lat", values.lat);
        formData.append("lng", values.lng);
        break;
      case "9":
        formData.append("freeShipping", values.freeShipping);
        formData.append("service", values.service);
        formData.append("costService", values.costService);
        break;
      default:
        break;
    }

    API.setting
      .update(formData)
      .then((result) => {
        message.success(result.message);
        this.setState({ submitting: false });
        this.fetch();
      })
      .catch(() => {
        this.setState({ submitting: false });
      });
  };

  componentDidMount() {
    const { onSetRoute, routeName, parentName } = this.props;

    onSetRoute({ openKey: parentName, selectedKey: routeName });

    this.fetch();
  }

  render() {
    const { activeTab, data, inviteImageList, loading, submitting } =
      this.state;

    const props = {
      onRemove: (file) => {
        this.setState({ inviteImageList: [] });
      },
      beforeUpload: (file) => {
        this.setState({ inviteImageList: [file] });
        return false;
      },
      showUploadList: {
        showRemoveIcon: false,
      },
      fileList: inviteImageList || [],
    };

    return (
      <Fragment>
        <Breadcrumb>
          <Breadcrumb.Item>{Resources.settings}</Breadcrumb.Item>
        </Breadcrumb>
        <div className="ant-content">
          <Tabs
            activeKey={activeTab}
            type="card"
            onTabClick={this.handleTabChange}
          >
            <Tabs.TabPane tab={Resources.countType} key="1" disabled={loading}>
              <CountTypes />
            </Tabs.TabPane>
            <Tabs.TabPane tab={Resources.shelf} key="2" disabled={loading}>
              <Shlfs />
            </Tabs.TabPane>
            <Tabs.TabPane tab={Resources.row} key="3" disabled={loading}>
              <Rows />
            </Tabs.TabPane>

            <Tabs.TabPane tab={Resources.chap} key="4" disabled={loading}>
              <PrintSizes />
            </Tabs.TabPane>

            <Tabs.TabPane tab={Resources.identifier} key="5" disabled={loading}>
              <ProductIdentifiers />
            </Tabs.TabPane>



          </Tabs>
        </div>
      </Fragment>
    );
  }
}

export default connect(null, (dispatch) => {
  return {
    onSetRoute: (data) => dispatch(SetRoute(data)),
  };
})(SettingsPage);
